import $ from 'jquery';

$(function($) {
	if ($('#salebanner').length > 0) {

		var endTime;
		var timeInterval;

		var clock       = document.getElementById('salebanner');
		var daysSpan    = clock.querySelector('.days');
		var hoursSpan   = clock.querySelector('.hours');
		var minutesSpan = clock.querySelector('.minutes');
		var secondsSpan = clock.querySelector('.seconds');

		function updateClock() {
			var now = Math.floor(Date.now());
			var t   = parseInt(endTime) * 1000 - now;

			var seconds = Math.floor((t / 1000) % 60);
			var minutes = Math.floor((t / 1000 / 60) % 60);
			var hours   = Math.floor((t / (1000 * 60 * 60)) % 24);

      daysSpan.innerHTML = Math.floor(t / (1000 * 60 * 60 * 24));
			hoursSpan.innerHTML = ('0' + hours).slice(-2);
			minutesSpan.innerHTML = ('0' + minutes).slice(-2);
			secondsSpan.innerHTML = ('0' + seconds).slice(-2);

			if (t <= 0) {
				clearInterval(timeInterval);
			}
		}

		function initializeClock() {
			// grab the acf field time/date value
			endTime = $('#salebanner').find('.countdownEnd').data('timestamp');
			timeInterval = setInterval(updateClock, 1000);
		}

    if ( daysSpan && hoursSpan && minutesSpan && secondsSpan ) {
      // target the salebanner div and start the timer
      initializeClock(endTime);
    }
	}
});
